<template>
    <div class="">
        <vueper-slides class="no-shadow"
                       :bullets="false"
                       :bulletsOutside="false"
                       :infinite="true"
                       :slide-ratio="1 / 5"
                       :visible-slides="3"
                       :gap="1"
                       :touchable="false"
                       :dragging-distance="200"
                       :breakpoints="breakpoints">

            <template #arrow-left>
                <i class="fa-solid fa-chevron-left txt-size-50"></i>
            </template>

            <template #arrow-right>
                <i class="fa-solid fa-chevron-right txt-size-50"></i>
            </template>

            <vueper-slide v-for="(item,index) in lstCursosDestaque" :key="index" :title="index.toString()">
                <template #content>
                    <div class="vueperslide__content-wrapper" style="flex-direction: row">
                        <div class="box-curso-carosel">
                            <router-link :to="{name:'Curso', params:{id:item.idTreinamento}}" class="w-100 h-100">
                                <div class="d-flex flex-wrap">
                                    <div class="col-12 col-lg-4 d-none d-lg-flex align-items-center pe-0">
                                        <img class="img-curso" :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" />

                                    </div>
                                    <div class="col-12 col-lg-8  ps-0">
                                        <div class="detalhes px-3 py-2 text-start">
                                            <span class="txt-p txt-size-12 txt-w-7 txt-cores-3 mb-1" v-if="!item.flGratis">
                                                Curso gratuito
                                            </span>
                                            <span v-else>
                                                &nbsp;
                                            </span>

                                            <p class=" txt-size-16 txt-w-7 txt-grey-3 mb-2 reduz-texto-1 mb-2">
                                                {{item.nmTreinamento}}
                                            </p>
                                            <p class="txt-p txt-size-12 txt-w-5 txt-grey-3 dsTreinamento reduz-texto-3 mb-1">
                                                {{item.dsTreinamento}}
                                            </p>
                                        </div>
                                        <div class="d-flex w-100 flex-wrap">
                                            <div class="col-12 col-md-6" style="background: #E4E4E4 ">
                                                <div class="d-flex flex-wrap justify-content-evenly w-100 h-100">
                                                    <div class="d-flex p-2 align-items-center">
                                                        <i class="txt-grey-5 fa-solid fa-book-bookmark txt-size-20"></i>
                                                        <div class="d-flex flex-column ms-2">
                                                            <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0 text-start">
                                                                Tema
                                                            </p>
                                                            <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0">
                                                                {{item.nmCategoria}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex p-2 align-items-center">
                                                        <i class="txt-grey-5 fa-regular fa-clock txt-size-20"></i>
                                                        <div class="d-flex flex-column ms-2">
                                                            <p class="txt-p txt-w-7 txt-size-10 txt-grey-3 mb-0">
                                                                Duração
                                                            </p>
                                                            <p class="txt-p txt-w-4 txt-size-10 txt-grey-3 mb-0">
                                                                {{item.duracaoTreinamento}} Horas
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6 ">
                                                <div class="d-flex flex-column py-2 px-3 justify-content-center">
                                                    <p class="txt-p txt-w-5 txt-size-10 txt-blue-3 mb-1">
                                                        Avaliação média dos usuários:
                                                    </p>
                                                    <Estrelas :nota="item.nota" :qtdAvaliacoes="item.qtdAvaliacoes"></Estrelas>
                                                </div>

                                            </div>
                                        </div>
                                        <router-link :to="{name:'Curso', params:{id:item.idTreinamento}}" class="">
                                            <div class="btn-curso bg-cores-3 d-flex w-100 justify-content-center py-2 c-pointer mt-3">
                                                <span class="txt-p txt-w-7 txt-size-12 txt-white">
                                                    Quero esse curso!
                                                </span>
                                            </div>
                                        </router-link>

                                    </div>
                                </div>
                            </router-link>
                        </div>

                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>   
    </div>
    
</template>

<script>
    import Estrelas from '@/components/Estrelas'
    import { VueperSlides, VueperSlide } from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'CarrosselDestaques',
        components: { Estrelas, VueperSlides, VueperSlide },
        data: function () {
            return {
                lstCursosDestaque: [],

                breakpoints: {
                    1800: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 6
                    },
                    1400: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 4
                    },
                    1300: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 4
                    },
                    1200: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 4
                    },
                    900: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 4
                    },
                    800: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 1
                    },
                    600: {
                        fixedHeight: "400px",
                        slideRatio: 1 / 1,
                    },
                },
            }
        },
        methods: {
            getCursosDestaque() {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/Get`, { params: { take: 6, index: 0, flCursoCapacitacao: true } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i].treinamento;

                                    item.duracaoTreinamento = (item.duracaoTreinamento == null ? 0 : Math.ceil(item.duracaoTreinamento / 3600));
                                    item.nota = res.data.data.rows[i].avaliacao.nota;
                                    item.qtdAvaliacoes = res.data.data.rows[i].avaliacao.qtdAvaliacoes;

                                    $this.lstCursosDestaque.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os destaques");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os destaques");
                    });
            },
        },
        created: function () {
            this.getCursosDestaque();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .vueperslides__parallax-wrapper {
        padding-bottom: 80% !important;
    }

    .box-curso-carosel {
        background: #FFFFFF;
        border: 2px solid #A6A6A6;
        box-sizing: border-box;
        border-radius: 10px;

        a {
            color: unset;
        }

        .img-curso {
            width: 112%;
            height: 100%;
            object-fit: cover;
            clip-path: polygon(75% 0%, 102% 100%, 0% 100%, 0% 0%);
            border-radius: 10px;
        }

        .conteudo {
            background: rgba(255, 255, 255, 0.25);
            border-left: 2px solid #A6A6A6;
            border-right: 2px solid #A6A6A6;
            box-sizing: border-box;
        }

        .detalhes {
            .dsTreinamento {
                min-height: 54px;
            }
        }

        .btn-curso {
            border-radius: 0 5px 5px 0;
        }

        .btn-curso:hover {
            background: #119b56 !important;
        }
    }
</style>

